import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import HomePage from "./pages/homepage/Homepage";
import SlideshowPage from "./pages/SlideshowPage/SlideShowPage";
import CelebrationsPage from "./pages/CelebrationsPage/CelebrationsPage";
import CallbackPage from "./pages/CallbackPage";
import MainLayout from "./components/ui/MainLayout/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";


function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LandingPage/>}/>
                <Route path="/auth" element={<AuthPage/>}/>
                <Route path="/auth/callback" element={<CallbackPage/>}/> {/* Redirect after Auth0 callback */}

                <Route element={
                    <ProtectedRoute>
                        <MainLayout/>
                    </ProtectedRoute>
                }
                >
                    <Route path="/home" element={<HomePage/>}/>
                    <Route path="/slideshow" element={<SlideshowPage/>}/>
                    <Route path="/celebrations" element={<CelebrationsPage />} />
                </Route>
            </Routes>
        </Router>

    );
}

export default App;


